import { request } from '@/utils/request/request';

// 获取配电室一次图数据
export function getDiagramData(data) {
  return request({
    url: 'api/equipment/v1/GetYiCiTu',
    method: 'get',
    params: data,
  });
}

// 获取设备某属性的对比曲线
export function getComparativeCurveData(data) {
  return request({
    url: 'api/equipment/v1/GetQvXian_By_EquipmentIDstr_DoubleLine',
    method: 'get',
    params: data,
  });
}
